<div class="space-y-6">
  <!-- Messages -->
  @if (successMessage()) {
    <div class="rounded-md bg-green-50 p-4">
      <p class="text-sm font-medium text-green-800">{{ successMessage() }}</p>
    </div>
  }

  @if (errorMessage()) {
    <div class="rounded-md bg-red-50 p-4">
      <p class="text-sm font-medium text-red-800">{{ errorMessage() }}</p>
    </div>
  }

  <!-- News Form -->
  <div class="bg-white shadow rounded-lg p-6">
    <h2 class="text-xl font-semibold text-gray-900 mb-4">
      {{ editingIndex() !== null ? 'Nachricht bearbeiten' : 'Neue Nachricht erstellen' }}
    </h2>

    <form (ngSubmit)="saveNews()" class="space-y-4">
      <div>
        <label for="headline" class="block text-sm font-medium text-gray-700">
          Überschrift *
        </label>
        <input
          type="text"
          id="headline"
          name="headline"
          [(ngModel)]="formHeadline"
          required
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
          placeholder="Überschrift eingeben"
        />
      </div>

      <div>
        <label for="textContent" class="block text-sm font-medium text-gray-700">
          Textinhalt (optional)
        </label>
        <textarea
          id="textContent"
          name="textContent"
          [(ngModel)]="formTextContent"
          rows="3"
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
          placeholder="Einfacher Text"
        ></textarea>
      </div>

      <div>
        <div class="flex justify-between items-center mb-1">
          <label for="htmlContent" class="block text-sm font-medium text-gray-700">
            HTML-Inhalt
          </label>
          <button
            type="button"
            (click)="openLinkPopup()"
            class="px-3 py-1 text-xs bg-green-100 text-green-700 rounded hover:bg-green-200 flex items-center gap-1"
          >
            <span>🔗</span>
            <span>Link einfügen</span>
          </button>
        </div>
        <textarea
          id="htmlContent"
          name="htmlContent"
          [(ngModel)]="formHtmlTextContent"
          rows="6"
          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border font-mono text-xs"
          placeholder="HTML-Code eingeben"
        ></textarea>
      </div>

      <div class="flex gap-3">
        <button
          type="submit"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          {{ editingIndex() !== null ? 'Aktualisieren' : 'Erstellen' }}
        </button>

        @if (editingIndex() !== null) {
          <button
            type="button"
            (click)="cancelEdit()"
            class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Abbrechen
          </button>
        }
      </div>
    </form>
  </div>

  <!-- News List -->
  <div class="bg-white shadow rounded-lg p-6">
    <h2 class="text-xl font-semibold text-gray-900 mb-4">Nachrichten</h2>

    @if (isLoading()) {
      <div class="text-center py-8">
        <p class="text-gray-500">Lädt...</p>
      </div>
    } @else if (newsList().length === 0) {
      <div class="text-center py-8">
        <p class="text-gray-500">Keine Nachrichten vorhanden</p>
      </div>
    } @else {
      <div class="space-y-4">
        @for (news of newsList(); track $index) {
          <div class="border border-gray-200 rounded-lg p-4 hover:border-gray-300">
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <h3 class="font-semibold text-lg text-gray-900">{{ news.Headline }}</h3>
                @if (news.TextContent) {
                  <p class="text-gray-600 mt-2">{{ news.TextContent }}</p>
                }
                @if (news.HtmlTextContent) {
                  <div class="mt-2 text-sm text-gray-500 font-mono bg-gray-50 p-2 rounded">
                    {{ news.HtmlTextContent.substring(0, 100) }}{{ news.HtmlTextContent.length > 100 ? '...' : '' }}
                  </div>
                }
              </div>
              <div class="flex gap-2 ml-4">
                <button
                  (click)="startEdit($index)"
                  class="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
                >
                  Bearbeiten
                </button>
                <button
                  (click)="confirmDeleteNews($index)"
                  class="px-3 py-1 text-sm bg-red-100 text-red-700 rounded hover:bg-red-200"
                >
                  Löschen
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Link Insertion Popup -->
  @if (showLinkPopup()) {
    <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
      <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div class="p-6">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-gray-900">Link einfügen</h3>
            <button
              type="button"
              (click)="closeLinkPopup()"
              class="text-gray-400 hover:text-gray-500"
            >
              <span class="text-2xl">&times;</span>
            </button>
          </div>

          <div class="space-y-4">
            <!-- Link Text -->
            <div>
              <label for="linkText" class="block text-sm font-medium text-gray-700">
                Link-Text *
              </label>
              <input
                type="text"
                id="linkText"
                [(ngModel)]="linkText"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                placeholder="z.B. Ausschreibungen, Mehr Info..."
              />
            </div>

            <!-- Link Type -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Link-Typ *
              </label>
              <div class="space-y-2">
                <label class="flex items-center">
                  <input
                    type="radio"
                    name="linkType"
                    [(ngModel)]="linkType"
                    value="ausschreibungen"
                    class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <span class="ml-2 text-sm text-gray-700">Ausschreibungen</span>
                </label>
                <label class="flex items-center">
                  <input
                    type="radio"
                    name="linkType"
                    [(ngModel)]="linkType"
                    value="ergebnisse"
                    class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <span class="ml-2 text-sm text-gray-700">Ergebnisse</span>
                </label>
                <label class="flex items-center">
                  <input
                    type="radio"
                    name="linkType"
                    [(ngModel)]="linkType"
                    value="external"
                    class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <span class="ml-2 text-sm text-gray-700">Externe URL</span>
                </label>
              </div>
            </div>

            <!-- External URL (shown only when external is selected) -->
            @if (linkType === 'external') {
              <div>
                <label for="externalUrl" class="block text-sm font-medium text-gray-700">
                  URL *
                </label>
                <input
                  type="url"
                  id="externalUrl"
                  [(ngModel)]="externalUrl"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                  placeholder="https://example.com"
                />
              </div>
            }

            <!-- Buttons -->
            <div class="flex gap-3 pt-4">
              <button
                type="button"
                (click)="insertLink()"
                class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Einfügen
              </button>
              <button
                type="button"
                (click)="closeLinkPopup()"
                class="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Delete Confirmation Modal -->
  @if (showDeleteConfirm()) {
    <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
      <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <!-- Modal Header -->
        <div class="px-6 py-4 border-b border-gray-200">
          <h3 class="text-lg font-semibold text-gray-900">Nachricht löschen</h3>
        </div>

        <!-- Modal Body -->
        <div class="px-6 py-4">
          <p class="text-gray-700">
            Möchten Sie die Nachricht <span class="font-semibold">"{{ newsToDelete()?.headline }}"</span> wirklich löschen?
          </p>
          <p class="text-sm text-gray-500 mt-2">
            Diese Aktion kann nicht rückgängig gemacht werden.
          </p>
        </div>

        <!-- Modal Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            (click)="cancelDelete()"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Abbrechen
          </button>
          <button
            (click)="deleteNews()"
            class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Löschen
          </button>
        </div>
      </div>
    </div>
  }
</div>
